module.exports = __webpack_public_path__ + "media/images/logos/brand-logo-web-brand-white-5436ea620602dfc0128c586a9213f705.png";